// extracted by mini-css-extract-plugin
export var readonly = "_g5-1";
export var star = "_g5-0";